import type { ID } from '@octopus-do/octopus-project-core'
import { CommentsActions } from '@store/reducers/comments'
import { useDispatch } from 'react-redux'

import { OpenConfirmation } from '@/store'

export const useCommentActions = (commentId: ID) => {
  const dispatch = useDispatch()

  const onDelete = () =>
    dispatch(
      OpenConfirmation({
        label: 'Delete',
        title: 'Delete comment',
        message: 'This comment will be permanently deleted. Are you sure?',
        then: [CommentsActions.delete({ id: commentId })],
      })
    )

  return { onDelete }
}
